import React, { useState, useEffect } from "react";
import currency from "currency.js";

const PricePointSelect = ({ 
  primary_price_point, 
  price_points, 
  onChange,
  className = '',
  containerClassName = '' 
}) => {
  const [availablePricePoints, setAvailablePricePoints] = useState([]);
  const [pricePointId, setPricePointId] = useState("");

  useEffect(() => {
    const parsedPricePoints = Array.isArray(price_points) ? price_points : JSON.parse(price_points || '[]');
    
    const openPricePoints = parsedPricePoints.filter(
      (point) => point && point.capacity > point.registration_count
    );
    openPricePoints.sort((a, b) => a.id - b.id);
    
    setAvailablePricePoints(openPricePoints);
    
    // Always start with empty selection
    setPricePointId("");
    if (typeof onChange === 'function') {
      onChange("");
    }
  }, [price_points, onChange]);

  const handlePricePointChange = (event) => {
    const newPricePointId = event.target.value;
    setPricePointId(newPricePointId);
    if (typeof onChange === 'function') {
      onChange(newPricePointId);
    }
  };

  const formatPrice = (cents) => {
    return currency(cents, { fromCents: true }).format();
  };

  const setUpOptions = (points) => {
    return [
      <option value="" disabled key="default">
        Select Registration Type
      </option>,
      ...points.map(({ id, title, price_cents }) => (
        <option value={id} key={id}>
          {`${title} - ${formatPrice(price_cents)}`}
        </option>
      ))
    ];
  };

  return (
    <div className={`camper-info-row ${containerClassName}`}>
      <label 
        htmlFor="price_point_select" 
        className="sr-only"
      >
        Registration Type (required)
      </label>
      <select
        className={`price_point field full-field ${className}`}
        id="price_point_select"
        name="price_point_id"
        value={pricePointId}
        onChange={handlePricePointChange}
        required
        aria-required="true"
        aria-invalid={pricePointId === ""}
      >
        {setUpOptions(availablePricePoints)}
      </select>
    </div>
  );
};

export default PricePointSelect;